import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import {Hash} from "~/interfaces/hashInterfaces";
import {EnumHelper} from "~/helpers/enumHelper";

export enum AggregateType {
  Sum = 1,
  Average = 2,
  Count = 3,
  Maximum = 4,
  Nanmean = 5, // (the mean ignoring NaN values, also known as "nil" or "null")
  Median = 6,
  Minimum = 7,
  Mode = 8,
}

interface IAggregateMetadata {
  label: string
}

export const AggregateMetadata: { [key in AggregateType]: Hash } = {
  [AggregateType.Sum]: {
    label: 'Sum',
  },
  [AggregateType.Average]: {
    label: 'Average',
  },
  [AggregateType.Count]: {
    label: 'Count',
  },
  [AggregateType.Maximum]: {
    label: 'Maximum',
  },
  [AggregateType.Nanmean]: {
    label: 'Nanmean',
  },
  [AggregateType.Median]: {
    label: 'Median',
  },
  [AggregateType.Minimum]: {
    label: 'Minimum',
  },
  [AggregateType.Mode]: {
    label: 'Mode',
  },
}

export function aggregateOptions(types: AggregateType[] = null): IDefaultVOption[] {
  let options = EnumHelper.toArray(AggregateType).map(enumVal => {
    return {label: AggregateMetadata[enumVal].label, value: enumVal}
  })
  if (types) options = options.filter(o => types.includes(o.value))
  return options
}
